var _rect, _line, _rect2, _path, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFridge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 385,
    height: 443,
    viewBox: "0 0 385 443",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1.27344,
    width: 385,
    height: 441.277,
    rx: 8,
    fill: "#E2E2E2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 193.084,
    y1: 7.52869e-8,
    x2: 193.084,
    y2: 441.277,
    stroke: "#806969",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 127.245,
    y: 172.113,
    width: 15.5199,
    height: 52.2045,
    rx: 7.75995,
    fill: "#806969"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.31 183.488C230.31 179.203 233.784 175.729 238.07 175.729C242.355 175.729 245.829 179.203 245.829 183.488V220.173C245.829 224.459 242.355 227.933 238.07 227.933C233.784 227.933 230.31 224.459 230.31 220.173V183.488Z",
    fill: "#806969"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 238.699,
    y: 69.3809,
    width: 27.9125,
    height: 29.4339,
    fill: "#EBC86E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 261.799,
    y: 91.4551,
    width: 27.9125,
    height: 29.4339,
    fill: "#B487CF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 165,
    width: 29,
    height: 28,
    fill: "#F78196"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFridge);
export default __webpack_public_path__ + "static/media/fridge.9570f35bf7afba08e1d8776f9739edf2.svg";
export { ForwardRef as ReactComponent };